import { useHits } from 'react-instantsearch';

//* Components
import { Container, useTranslation, Text } from '@weareconceptstudio/core';
import Hit from './Hit';

const Hits = (props) => {
	const { translate, selectedLang } = useTranslation();
	const { hits } = useHits(props);

	if (!hits.length) {
		return (
			<div className='no-results'>
				<Text
					tag='h4'
					text={translate('no_results')}
					className='h4 black-1000 montserrat-400  text-center'
				/>
				<Text
					tag='p'
					text={translate('no_results_desc')}
					className='p p2 black-1000 montserrat-400 text-center mt-2'
				/>
			</div>
		);
	}

	return (
		<div className='bottom-wrapper col-12'>
			<Container
				row
				full
				className={`bottom-container`}>
				{hits.map((i, k) => {
					return (
						<div
							key={k}
							className='item-hit col-4 col-m-12'>
							<Hit
								{...i}
								imagePrefix={props.imagePrefix}
							/>
						</div>
					);
				})}
			</Container>
		</div>
	);
};

export default Hits;
